export default "__VITE_ASSET__CsstVte1__"